import _objectSpread from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.push.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import staffSearch from '_c/staff-search';
import { managerInfo as _managerInfo, managerCreate, managerEdit } from 'api/settings';
import framework from '_c/framework';
import { countStaffs } from 'api/Attendance';
var fromData = function fromData() {
  return {
    privilege_manager_id: '',
    staff_name: '',
    staff_id: '',
    range_staffs: [],
    num: 0,
    range: '2',
    group_ids: [],
    range_staff_ids: [],
    range_deps: [],
    range_department_ids: []
  };
};
export default {
  components: {
    staffSearch: staffSearch,
    framework: framework
  },
  data: function data() {
    return {
      orgVisible: false,
      visible: false,
      loading: false,
      fromData: fromData(),
      groupOptions: [],
      rules: {
        staff_id: [{
          required: true,
          message: this.$t('i18n.05c9a3d041714c61983a57d1eaca3e98'),
          trigger: ['blur', 'change']
        }],
        group_ids: [{
          required: true,
          message: this.$t('i18n.9f33ea801fba4a308a41ef2901edbd67'),
          trigger: ['blur', 'change']
        }],
        range: [{
          required: true,
          message: this.$t('221'),
          trigger: ['blur', 'change']
        }]
      }
    };
  },
  methods: {
    handleClose: function handleClose() {
      this.$refs.ruleForm.clearValidate();
      this.visible = false;
      this.fromData = fromData();
    },
    init: function init(obj, options) {
      this.visible = true;
      if (obj) this.managerInfo(obj.privilege_manager_id);
      this.groupOptions = options;
      this.fromData = fromData();
    },
    managerInfo: function managerInfo(privilege_manager_id) {
      var _this = this;
      _managerInfo({
        privilege_manager_id: privilege_manager_id
      }).then(function (_ref) {
        var data = _ref.data;
        _this.fromData = _objectSpread(_objectSpread({}, _this.fromData), data);
        data.groups.forEach(function (item) {
          _this.fromData.group_ids.push(item.group_id);
        });
        data.range_staffs.forEach(function (item) {
          _this.fromData.range_staff_ids.push(item.staff_id);
        });
        data.range_deps.forEach(function (item) {
          _this.fromData.range_department_ids.push(item.department_id);
        });
        _this.getSelectNum({
          depIds: _this.fromData.range_department_ids,
          staffIds: _this.fromData.range_staff_ids
        });
      });
    },
    getSelectStaff: function getSelectStaff(params) {
      this.fromData = _objectSpread(_objectSpread({}, this.fromData), params);
    },
    changeRadio: function changeRadio(val) {
      if (val !== '3') this.handlerSelected({});
    },
    // 回显去重之后的人数
    getSelectNum: function getSelectNum(_ref2) {
      var _this2 = this;
      var _ref2$depIds = _ref2.depIds,
        depIds = _ref2$depIds === void 0 ? [] : _ref2$depIds,
        _ref2$staffIds = _ref2.staffIds,
        staffIds = _ref2$staffIds === void 0 ? [] : _ref2$staffIds;
      countStaffs({
        department_ids: depIds,
        staff_ids: staffIds
      }).then(function (res) {
        _this2.fromData.num = res.data.staff_num;
        _this2.$forceUpdate();
      });
    },
    // 选人回掉
    handlerSelected: function handlerSelected(params) {
      // 已选数据
      this.fromData.range_staffs = params.staff_list || [];
      this.fromData.range_staff_ids = params.staffIds || [];
      this.fromData.range_deps = params.dept_list || [];
      this.fromData.range_department_ids = params.depIds || [];
      this.fromData.num = 0;
      if (params.staffIds) this.getSelectNum(params);
    },
    // 添加成员
    handlerAddStaff: function handlerAddStaff() {
      var _this3 = this;
      if (!this.fromData.num && this.fromData.range === '3') {
        this.$message.warning(this.$t('i18n.9a1501b4fe8146fa9f1c9a1d601be189'));
        return;
      }
      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          _this3.loading = true;
          var query = _objectSpread({}, _this3.fromData);
          var api = managerCreate;
          if (_this3.fromData.privilege_manager_id) {
            api = managerEdit;
            query.privilege_manager_id = _this3.fromData.privilege_manager_id;
          } else {
            query.staff_id = _this3.fromData.staff_id;
          }
          api(query).then(function () {
            _this3.$parent.handlerGroupStaffList(1);
            _this3.handleClose();
            _this3.$message.success({
              title: _this3.$t('818'),
              message: _this3.$t('819'),
              type: 'success'
            });
          }).finally(function () {
            _this3.loading = false;
          });
        }
      });
    }
  }
};